export let closeCopilotChatDrawer = "HQYKYc";
export let expandCopilotChatDrawer = "HNFvPd";
export let collapseCopilotChatDrawer = "gtb6Ad";
export default {closeCopilotChatDrawer,expandCopilotChatDrawer,collapseCopilotChatDrawer};